import React from 'react'
import DocumentTitle from 'react-document-title'
import { RegistrationForm } from '../components'


export default class RegistrationPage extends React.Component {
  render() {
    return (
      <DocumentTitle title={'Café App'}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h3>Registration</h3>
              <hr />
            </div>
          </div>
          <RegistrationForm />
        </div>
      </DocumentTitle>
    )
  }
}
